.root {
  display: inline-flex;
  position: relative;
}

.bubble {
  animation: fadeIn 0.15s ease-out;
  background: var(--color-tooltip-bg);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  // Size to content (short labels stay snug); long copy caps + wraps at 260px.
  max-width: 260px;
  min-width: 0;
  padding: 6px 10px;
  width: max-content;
  pointer-events: none;
  // Portal-rendered into document.body; inline `top` + `left` + `transform`
  // come from the JS positioner (see tooltip.tsx). Stays out of ancestor
  // `overflow: hidden` clipping by virtue of escaping the DOM subtree.
  position: fixed;
  z-index: 50;
}

// Rich variant — long text (e.g. a Description cell up to ~2500 chars): a wide
// box that wraps normally with auto height and NO internal scroll (nothing is
// truncated inside). Defined after `.bubble` so its wider `max-width` wins the
// equal-specificity tie. Viewport clamping (see tooltip.tsx) keeps it on-screen.
.bubble-rich {
  max-width: 680px;
  white-space: normal;
}

.text {
  color: var(--color-tooltip-fg);
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.4;
  white-space: normal;
  word-break: break-word;
}

.arrow {
  height: 6px;
  position: absolute;
  width: 6px;
}

// Per-position arrow placement only — bubble positioning is handled by
// the JS-computed inline `top/left/transform` (see tooltip.tsx).
.pos-top .arrow {
  background: var(--color-tooltip-bg);
  bottom: -3px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
}

.pos-bottom .arrow {
  background: var(--color-tooltip-bg);
  left: 50%;
  top: -3px;
  transform: translateX(-50%) rotate(45deg);
}

.pos-left .arrow {
  background: var(--color-tooltip-bg);
  right: -3px;
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
}

.pos-right .arrow {
  background: var(--color-tooltip-bg);
  left: -3px;
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
